// extracted by mini-css-extract-plugin
export var bodySections = "_6u-8";
export var gray = "_6u-7";
export var green = "_6u-4";
export var iconContainer = "_6u-9";
export var iconWidgetContainer = "_6u-1";
export var phoneIcon = "_6u-2";
export var red = "_6u-5";
export var statusDot = "_6u-3";
export var widgetContainer = "_6u-0";
export var yellow = "_6u-6";